// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_STROLLERS = "%(count)s ko\u010d\u00e1rk\u016f";
export const STROLLERS_SEARCH = "Vyhled\u00e1v\u00e1n\u00ed";
export const STROLLERS_SEARCH_FORM_EDIT = "Up\u0159esni parametry ko\u010d\u00e1rku";
export const STROLLERS_SEARCH_NO_RESULTS = "Nena\u0161li jsme \u017e\u00e1dn\u00e9 ko\u010d\u00e1rky, kter\u00e9 vyhovuj\u00ed podm\u00ednk\u00e1m vyhled\u00e1v\u00e1n\u00ed.";
export const STROLLERS_SEARCH_REMOVE_ALL = "Zru\u0161 v\u0161e";
export const STROLLERS_SEARCH_RESULTS_BRANDS = "Podstr\u00e1nky zna\u010dek s dal\u0161\u00edmi informacemi:";
export const STROLLERS_SEARCH_RESULTS_results = "Ko\u010d\u00e1rky: %(results)s ";
export const STROLLERS_SEARCH_SORT_RESULTS_BY_NAME = "A-Z";
export const STROLLERS_SEARCH_SORT_RESULTS_BY_PRICE_ASC = "Nejlevn\u011bj\u0161\u00ed";
export const STROLLERS_SEARCH_SORT_RESULTS_BY_PRICE_DESC = "Nejdra\u017e\u0161\u00ed";
export const STROLLERS_SEARCH_SORT_RESULTS_BY_RATING = "Nejl\u00e9pe hodnocen\u00e9";
export const STROLLERS_SEARCH_SORT_RESULTS_BY_RECOMMENDED = "Doporu\u010den\u00e9 redakc\u00ed";
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00e1rkopedie";
